// extracted by mini-css-extract-plugin
export var dropdownButton = "_23-0";
export var fullWidthDropdownButton = "_23-1";
export var icon = "_23-3";
export var iconPlaceholder = "_23-2";
export var menuItemRow = "_23-5";
export var shortcutContainer = "_23-4";